import React, { Component } from "react";
import PropTypes from "prop-types";
import ProductListingPage from "../../containers/ProductListingPage";
import SearchAdvert from "../../containers/SearchAdvert";
import activateSearchMvt from "./activateSearchMvt";

export class SearchPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { mvtParams } = this.props;

    activateSearchMvt(mvtParams);
  }

  render() {
    return <ProductListingPage Advert={SearchAdvert} {...this.props} />;
  }
}

SearchPage.propTypes = {
  mvtParams: PropTypes.object.isRequired
};

export default SearchPage;
